import { computed, ref } from "vue";
import { useStore } from "vuex";
import {
  SET_CHOOSE_ANSWER,
  SET_CURRENT_MATRIX_PAGE_INDEX,
  SET_MATRIX_ANSWER,
} from "../store/modules/survey/mutations";
import { arrayRemove } from "../utils";
import { language } from "../language";
import { popupState } from "./popupHook";
export const commonAnswerInfo = ref([
  {
    chooseIndex: 0,
    edit: "",
  },
]);
export const singleEditInfo = ref("");
export const collectInfo = ref({
  phone: "",
  email: "",
  phoneArea: "",
});
export const checkTips = ref(""); // 检测用提示语
export default function () {
  const store = useStore();
  const currentQuestionType = computed(
    () => store.getters["survey/currentQuestionType"]
  );
  const currentAnswerConfig = computed(
    () => store.getters["survey/currentAnswerConfig"]
  );
  const currentButtonType = computed(
    () => store.getters["survey/currentButtonType"]
  );
  const currentAnswerConfigArray = computed(
    () => store.getters["survey/currentAnswerConfigArray"]
  );
  const chooseArray = computed(() => store.state.survey.chooseAnswer);
  const translate = computed(() => store.state.survey.translate);
  const matrixAnswerArray = computed(() => store.state.survey.matrixAnswer);
  const currentMatrixPageIndex = computed(
    () => store.state.survey.currentMatrixPageIndex
  );
  const isMatrixSingle = computed(
    () => currentQuestionType.value === "matrixSingle"
  );
  const chooseEvent = (id) => {
    if (
      currentQuestionType.value === "singleChoose" ||
      currentQuestionType.value === "NPS"
    ) {
      // 单选直接记录
      store.commit(`survey/${SET_CHOOSE_ANSWER}`, [id]);
    }
    if (currentQuestionType.value === "multipleChoose") {
      // 多选考虑反选与互斥
      let currentChooseArray = chooseArray.value;
      let isMutex = currentAnswerConfigArray.value[id].mutex;
      let mutexArray = currentAnswerConfigArray.value
        .map((item, index) => {
          item.index = index;
          return item;
        })
        .filter((item) => item.mutex === true)
        .map((item) => item.index); // 获取互斥下标
      let hasMutex = currentChooseArray.some((chooseIndex) =>
        mutexArray.includes(chooseIndex)
      );
      if (hasMutex) {
        // 如果已经选择互斥选项，选择其他则自动取消互斥选项
        mutexArray.forEach((id) => {
          currentChooseArray = arrayRemove(currentChooseArray, id);
        });
      }
      currentChooseArray = currentChooseArray.includes(id)
        ? arrayRemove(currentChooseArray, id)
        : [...currentChooseArray, id];
      if (isMutex) {
        // 选择互斥选项则取消其他所有
        currentChooseArray = [id];
      }

      // 检查是否有多选个数限制
      let maxCount = currentAnswerConfig.value.maxChooseCount;
      if (maxCount && currentChooseArray.length > maxCount) {
        const tipsContent = language
          .getTextByKey("leastChoose")
          .replace("xxx", maxCount);
        checkTips.value = tipsContent;
        popupState.tips = tipsContent;
        return;
      }

      store.commit(`survey/${SET_CHOOSE_ANSWER}`, currentChooseArray);
    }
  };

  const matrixEvent = (rowId, chooseId) => {
    let currentMatrixArray = matrixAnswerArray.value;
    currentMatrixArray[rowId] = chooseId;
    store.commit(`survey/${SET_MATRIX_ANSWER}`, currentMatrixArray);
    commonAnswerInfo.value[rowId].chooseIndex = chooseId;
  };
  const nextMatrixPage = () => {
    currentMatrixPageIndex.value <
      currentAnswerConfig.value.rowTitleArray.length - 1 &&
      store.commit(
        `survey/${SET_CURRENT_MATRIX_PAGE_INDEX}`,
        currentMatrixPageIndex.value + 1
      );
  };
  const prevMatrixPage = () => {
    currentMatrixPageIndex.value > 0 &&
      store.commit(
        `survey/${SET_CURRENT_MATRIX_PAGE_INDEX}`,
        currentMatrixPageIndex.value - 1
      );
  };
  return {
    chooseEvent,
    matrixEvent,
    nextMatrixPage,
    prevMatrixPage,
    isMatrixSingle,
    currentQuestionType,
    currentButtonType,
    matrixAnswerArray,
    currentAnswerConfigArray,
    currentAnswerConfig,
    commonAnswerInfo,
    collectInfo,
    singleEditInfo,
    chooseArray,
    translate,
  };
}
